import { Box } from '@mui/material';
import { DropDown, ChipInput, ChipInputTagErrors } from '@qrios/frontend-library';

import DateRangePicker from '../../../../../../common/fields/date-range-picker';
import { FiltersFormValues } from '../../../../../../common/reports/interfaces';
import { BILLING_STATUSES, FILTERS } from '../../../../../../common/filters/constants';

import locales from '../locales';
import { CustomerAuthenticationReportCreateForm } from '../interfaces';
import { CUSTOMER_AUTHENTICATION_PROVIDERS } from '../../billing/filters';

interface Props extends FiltersFormValues<CustomerAuthenticationReportCreateForm> {}

const FiltersForm = ({ errors, touched, values, handleChange, handleBlur }: Props) => (
  <Box mt={2} mb={6}>
    <DateRangePicker
      from={{ name: FILTERS.FROM, value: values.from, error: errors.from, touched: touched.from }}
      to={{ name: FILTERS.TO, value: values.to, error: errors.to, touched: touched.to }}
      handleFromChange={value => handleChange(FILTERS.FROM, value)}
      handleToChange={value => handleChange(FILTERS.TO, value)}
      handleBlur={handleBlur}
    />
    <DropDown
      label={locales.filtersForm.statuses.label}
      placeholder={locales.filtersForm.statuses.placeholder}
      value={values.statuses}
      options={BILLING_STATUSES}
      name="statuses"
      handleChange={handleChange}
      handleBlur={handleBlur}
      multiple={true}
    />
    <ChipInput
      error={errors.operationIds?.[(errors.operationIds ?? []).length - 1]}
      label={locales.filtersForm.operationIds.label}
      value={values.operationIds}
      name="operationIds"
      handleChange={handleChange}
      handleBlur={handleBlur}
      placeholder={locales.filtersForm.operationIds.placeholder}
      tagErrors={errors.operationIds as ChipInputTagErrors}
    />
    <ChipInput
      error={errors.customerMsisdns?.[(errors.customerMsisdns ?? []).length - 1]}
      label={locales.filtersForm.customerMsisdns.label}
      value={values.customerMsisdns}
      name="customerMsisdns"
      handleChange={handleChange}
      handleBlur={handleBlur}
      placeholder={locales.filtersForm.customerMsisdns.placeholder}
      tagErrors={errors.customerMsisdns as ChipInputTagErrors}
    />
    <DropDown
      label={locales.filtersForm.providerNames.label}
      placeholder={locales.filtersForm.providerNames.placeholder}
      value={values.providerNames}
      options={CUSTOMER_AUTHENTICATION_PROVIDERS}
      name="providerNames"
      handleChange={handleChange}
      handleBlur={handleBlur}
      multiple={true}
    />
  </Box>
);

export default FiltersForm;
